export const USER = "user"
export const ORGANIZATION = "organization"
